import { Query } from 'react-apollo';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import getMedia from '../../graphql/queries/media.graphql';
import createErrorVideoData from './utils/createErrorVideoData';
import personalAdConsent from '../../util/personalAdConsent';
import atInternetId from '../../util/atInternetId';
import getSitenameFromUrl from '../../util/sitenameFromUrl';
import {
  BNNVARA_VIDEO_PLAYER_TYPE,
  NPO_VIDEO_PLAYER_TYPE,
} from '../mediaplayers/MediaPlayer';

/**
 * This is a temporary transform function until we receive final data from the backend.
 * Missing data will be populated with mock data.
 *
 * @param data
 * @returns object
 */
const createVideoData = ({ mediaId, media }) => {
  let videoData = {
    mediaId,
    type: media.type,
    title: media.title,
  };

  document.title = media.title;

  if (videoData.type === NPO_VIDEO_PLAYER_TYPE) {
    videoData = {
      ...videoData,
      embedId: media.token,
    };
  }

  if (videoData.type === BNNVARA_VIDEO_PLAYER_TYPE) {
    videoData = {
      ...videoData,
      prid: null,
      duration: 12345,
      programTitle: media.title,
      genres: media.genres,
      site: getSitenameFromUrl(window.referrer || document.location.href),
      playername: 'bnnvara-web',
      classifications: media.classifications,
      broadcasters: media.broadcasters
        .map(broadcaster => broadcaster.name.toLowerCase())
        .join(','),
      poster: get(media, 'image.url', null),
      source: media.sources.map(source => ({
        src: source.url,
        type: source.type || 'video/mp4',
        name: source.name || 'HD',
        ratio: source.ratio || '16:9',
      })),
      subtitles: [],
    };

    // For testing purposes we add a test subtitle to the video object.
    if (!videoData.subtitles.length && process.env.NODE_ENV === 'development') {
      videoData.subtitles.push({
        kind: 'subtitles',
        src:
          'https://rs.poms.omroep.nl/v1/api/subtitles/KN_1700909/nl_NL/CAPTION.vtt',
        language: 'nl',
        srcLang: 'nl',
        label: 'Nederlands',
      });
    }
  }

  return videoData;
};

/**
 * This component expects an id and a render prop function.
 * Once the data is loaded it will use the render prop to render its children.
 */
export default class VideoDataQuery extends Component {
  static propTypes = {
    id: PropTypes.string.isRequired,
    render: PropTypes.func.isRequired,
  };

  renderLegacy() {
    const { id, render } = this.props;

    const {
      data: { video: videoData },
    } = get(window, 'params');

    const video = createVideoData({
      mediaId: id,
      media: {
        ...videoData,
        type: 'video',
        broadcasters: [{ name: videoData.broadcaster }],
      },
    });

    return render(video);
  }

  render() {
    const { id, render } = this.props;

    if (get(window, 'params')) {
      return this.renderLegacy();
    }

    return (
      <Query
        query={getMedia}
        variables={{
          id,
          hasAdConsent: personalAdConsent(),
          atInternetId: atInternetId(),
        }}
      >
        {({ loading, data: videoData, error }) => {
          if (loading) return null;

          const video = error
            ? createErrorVideoData(error)
            : createVideoData({
                mediaId: id,
                ...videoData,
              });

          return render(video);
        }}
      </Query>
    );
  }
}
